module.exports = __webpack_public_path__ + "static/media/cylinder.34ce68b1.svg";